import { Group, Stack, Text } from '@mantine/core'
import classes from './css/Footer.module.css'
import { useMediaQuery } from '@mantine/hooks'

export const Footer = () => {
  const isMobile = useMediaQuery('(max-width: 768px)')

  return (
    <Group
      className={classes.container}
      justify='space-between'
      align='center'
      wrap='wrap'
      gap='md'
    >
      <Text
        style={{
          color: 'white',
          flexShrink: 0,
        }}
      >
        © Copyright Hidden Gemz {new Date().getFullYear()}
      </Text>

      <Stack
        gap={8}
        justify={isMobile ? 'center' : 'flex-end'}
        style={{
          flexShrink: 1,
          minWidth: 0,
        }}
      >
        <Text
          style={{
            textDecoration: 'underline',
            textAlign: isMobile ? 'left' : 'right',
          }}
        >
          <a
            href='mailto:support@hiddengemz.tv?subject=Hidden Gemz Support'
            style={{ color: 'white' }}
          >
            Need help?
          </a>
        </Text>

        <Group
          gap={16}
          justify={isMobile ? 'center' : 'flex-end'}
          style={{
            flexWrap: 'wrap',
          }}
        >
          <Text size='sm' style={{ textDecoration: 'underline' }}>
            <a
              href='https://www.hiddengemz.tv/terms-and-conditions'
              style={{ color: 'white' }}
              target='_blank'
              rel='noopener noreferrer'
            >
              Terms of Service
            </a>
          </Text>

          <Text size='sm' style={{ textDecoration: 'underline' }}>
            <a
              href='https://www.hiddengemz.tv/privacy-policy'
              style={{ color: 'white' }}
              target='_blank'
              rel='noopener noreferrer'
            >
              Privacy Policy
            </a>
          </Text>

          <Text size='sm' style={{ textDecoration: 'underline' }}>
            <a
              href='https://www.hiddengemz.tv/cookie-policy'
              style={{ color: 'white' }}
              target='_blank'
              rel='noopener noreferrer'
            >
              Cookie Policy
            </a>
          </Text>
        </Group>
      </Stack>
    </Group>
  )
}
